import React from "react";
import { cn } from "../../../lib/utils";
import { Bot, Server, ArrowRight } from "lucide-react";

interface FlowNode {
  label: string;
  sublabel?: string;
  icon: React.ReactNode;
  metadata?: Record<string, string>;
}

interface GatewayFlowDiagramProps {
  agentName?: string;
  serverName?: string;
  sessionId?: string;
  requestId?: string;
  correlationId?: string;
  className?: string;
}

export default function GatewayFlowDiagram({
  agentName, serverName, sessionId, requestId, correlationId, className,
}: GatewayFlowDiagramProps) {
  const nodes: FlowNode[] = [
    {
      label: agentName || "AI Agent",
      sublabel: "Agent",
      icon: <Bot className="w-5 h-5" />,
      metadata: sessionId ? { "Session": sessionId } : undefined,
    },
    {
      label: "WS Gateway",
      sublabel: "Orchestration",
      icon: <Server className="w-5 h-5" />,
      metadata: {
        ...(correlationId ? { "Correlation": correlationId } : {}),
        ...(requestId ? { "Request": requestId } : {}),
      },
    },
    {
      label: serverName || "MCP Server",
      sublabel: "Target",
      icon: <Server className="w-5 h-5" />,
    },
  ];

  return (
    <div className={cn("flex items-center justify-center gap-2 py-4", className)}>
      {nodes.map((node, i) => (
        <React.Fragment key={i}>
          <div className="flex flex-col items-center gap-2 min-w-[140px]">
            <div className="flex items-center justify-center w-12 h-12 rounded-xl bg-muted/80 border border-border text-primary">
              {node.icon}
            </div>
            <div className="text-center">
              <div className="text-sm font-medium text-foreground truncate max-w-[160px]">{node.label}</div>
              {node.sublabel && <div className="text-xs text-muted-foreground">{node.sublabel}</div>}
            </div>
            {node.metadata && Object.keys(node.metadata).length > 0 && (
              <div className="space-y-0.5 text-center">
                {Object.entries(node.metadata).map(([k, v]) => (
                  <div key={k} className="text-[10px] text-muted-foreground font-mono truncate max-w-[160px]">{k}: {v}</div>
                ))}
              </div>
            )}
          </div>
          {i < nodes.length - 1 && (
            <ArrowRight className="w-5 h-5 text-muted-foreground/70 shrink-0 mx-1" />
          )}
        </React.Fragment>
      ))}
    </div>
  );
}
